import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { PencilButtonComponent } from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { PencilMenuItemComponent } from 'src/app/standalones/components/pencil-menu-item/pencil-menu-item.component';
import {
  PencilIconComponent,
  IconTypes,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { AlertPriority, PriorityConfig } from '../../models/alert';
import { AlertViewModelFactory } from '../view-models/alert-view-model-factory.service';

@Component({
  selector: 'app-alert-priority-dropdown',
  templateUrl: './alert-priority-dropdown.component.html',
  styleUrls: ['./alert-priority-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    PencilButtonComponent,
    PencilMenuItemComponent,
    PencilIconComponent,
  ],
})
export class AlertPriorityDropdownComponent {
  IconTypes = IconTypes;

  @Input() priority!: AlertPriority;
  @Output() priorityChange = new EventEmitter<AlertPriority>();

  // Snapshotted per the getter's contract, since the array is bound in `*ngFor`.
  // Reading at construction is safe because this component is built when the
  // details panel opens, long after the locale JSON has loaded.
  readonly priorityOptions: PriorityConfig[];

  constructor(alertViewModelFactory: AlertViewModelFactory) {
    this.priorityOptions = alertViewModelFactory.priorityConfigs;
  }

  get currentOption() {
    return this.priorityOptions.find((opt) => opt.id === this.priority);
  }

  onPriorityChange(priorityId: AlertPriority) {
    this.priorityChange.emit(priorityId);
  }
}
